import { render, staticRenderFns } from "./ResultOptions.vue?vue&type=template&id=2b97c5ce&"
import script from "./ResultOptions.vue?vue&type=script&lang=js&"
export * from "./ResultOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports